import React from "react";
import { NavLink } from "react-router-dom";
import { ReactDOM } from "react";
import iconHome from '../../assets/bouton-daccueil (1).png'
import iconTeam from '../../assets/structure.png'
import iconAbout from '../../assets/a-propos.png'
import iconContact from '../../assets/contacter-le-carnet.png'
import iconLogIn from '../../assets/sortie.png'
import './navBar.css'
import logo from '../../assets/SGN_04_25_2023_1682462832504.png'
function Navbar (){
    const color = () => {
        return {color:'green'}
    }
    return <div className="bg-navBar">
        <div className="logoName">
            {(function dashApp(){
                return <img src={logo} alt="logo dash app" className="LogoNav" ></img>
                })()
            }
            <h2>DASH_APP</h2>
        </div>
        <div className="nav">

            <div className="navs">
                <div className="navHome">
                    <img src={iconHome}  alt="home"  />
                    <NavLink to="/" className='NavLink'  >Home</NavLink>
                </div>
                <div className="navHome">
                    <img src={iconTeam}  alt="team" />
                    <NavLink to ="/team"  className='NavLink' >Team</NavLink>
                </div>
                <div className="navHome">
                     <img src={iconAbout}  alt="about"  />
                    <NavLink to="/about" className='NavLink'   >About</NavLink>
                </div>
                <div className="navHome">
                    <img src={iconContact}  alt=""  />
                    <NavLink to="/contact" className='NavLink'   >Contact</NavLink>
                </div>
                
            </div>
            <div className="navTablette">
                <div className="navHome">
                    <NavLink to="/" className='NavLink'   >
                        <img src={iconHome}  alt="home"  />
                    </NavLink>
                </div>
                <div className="navHome">
                    <NavLink to ="/team"  className='NavLink' >
                        <img src={iconTeam}  alt="team" />
                    </NavLink>
                </div>
                <div className="navHome">
                    <NavLink to="/about" className='NavLink'   >
                        <img src={iconAbout}  alt="about"  />
                    </NavLink>
                </div>
                <div className="navHome">
                    <NavLink to="/contact" className='NavLink'   >
                        <img src={iconContact}  alt=""  />
                    </NavLink>
                </div>
                
            </div>
            <div className="navTablette2">
                <NavLink to="/contact" className='NavLink'   >FR</NavLink>
                <div className="navHome">
                    <NavLink to="/login" className='NavLink'    >
                        <img src={iconLogIn} width={'30px'} alt=""  />
                    </NavLink>
                </div>
            </div>
            <div className="navs">
                <NavLink to="/contact" className='NavLink'   >FR</NavLink>
                <div className="navHome">
                    <NavLink to="/login" className='NavLink'    >
                        <img src={iconLogIn} width={'30px'} alt=""  />
                    </NavLink>
                </div>
            </div>
        </div>
        
    </div>
}

export default Navbar
